// extracted by mini-css-extract-plugin
module.exports = {"innerImgWrapper":"img-module--innerImgWrapper--ulTkw","overlay":"img-module--overlay--3i_Yq","img":"img-module--img--26BHm","effect":"img-module--effect--5ZhwW"};